export { default } from './ChildReviews';



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductReviewList/ChildReviews/index.js